import React from "react";
import OTPInput from "react-otp-input";
import CardSection from "../../components/Card/CardSection";
import {
  CheckCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export default function PinSetupFragment({ setInputPin, inputPin }) {
  return (
    <div className="mx-auto max-w-lg">
      <form className="mt-4 space-y-4">
        <div className="space-y-2">
          <CardSection title="Atur PIN (6 digit angka)">
            <div className="space-y-3">
              <OTPInput
                value={inputPin.pin}
                name="pin"
                onChange={(value) => setInputPin({ ...inputPin, pin: value })}
                numInputs={6}
                inputType="tel"
                containerStyle="flex justify-between"
                renderInput={(props) => <input {...props} />}
                inputStyle="otp-input h-12 !w-12 text-center text-xl font-bold text-gray-700"
              />
              <div className="space-y-2">
                <div className="flex justify-between">
                  <p className="text-xs text-monochrome-400">
                    Masukkan kembali PIN untuk konfirmasi
                  </p>
                  <span className="text-sm font-medium text-gray-400">
                    {inputPin.pin === inputPin.pin_verify &&
                    inputPin.pin_verify.length === 6 ? (
                      <CheckCircleIcon className="size-6 text-green-600" />
                    ) : (
                      <XMarkIcon className="size-6 text-red-500" />
                    )}
                  </span>
                </div>
                <OTPInput
                  value={inputPin.pin_verify}
                  name="pin"
                  onChange={(value) =>
                    setInputPin({ ...inputPin, pin_verify: value })
                  }
                  numInputs={6}
                  inputType="tel"
                  containerStyle="flex justify-between"
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp-input h-12 !w-12 text-center text-xl font-bold text-gray-700"
                />
              </div>
            </div>
          </CardSection>
        </div>
      </form>
    </div>
  );
}
